import {
  FETCH_SHIFT_GROUPS, FETCH_SHIFT_GROUPS_SUCCESS, FETCH_SHIFT_GROUPS_FAILURE,
  CREATE_SHIFT_GROUP, CREATE_SHIFT_GROUP_SUCCESS, CREATE_SHIFT_GROUP_FAILURE,
  UPDATE_SHIFT_GROUP, UPDATE_SHIFT_GROUP_SUCCESS, UPDATE_SHIFT_GROUP_FAILURE,
  DELETE_SHIFT_GROUP, DELETE_SHIFT_GROUP_SUCCESS, DELETE_SHIFT_GROUP_FAILURE
} from "./actionTypes";

// Fetch Shift Groups
export const fetchShiftGroups = (unitId) => ({ type: FETCH_SHIFT_GROUPS, payload: { unitId } });
export const fetchShiftGroupsSuccess = (shiftGroups) => ({ type: FETCH_SHIFT_GROUPS_SUCCESS, payload: shiftGroups });
export const fetchShiftGroupsFailure = (error) => ({ type: FETCH_SHIFT_GROUPS_FAILURE, payload: error });

// Create Shift Group
// export const createShiftGroup = (shiftGroup) => ({ type: CREATE_SHIFT_GROUP, payload: shiftGroup });
export const createShiftGroup = (formData) => {
  return { type: CREATE_SHIFT_GROUP, payload: {formData} };
};
export const createShiftGroupSuccess = (shiftGroup) => ({ type: CREATE_SHIFT_GROUP_SUCCESS, payload: shiftGroup });
export const createShiftGroupFailure = (error) => ({ type: CREATE_SHIFT_GROUP_FAILURE, payload: error });

// Update Shift Group
export const updateShiftGroup = (shiftGroup) => ({ type: UPDATE_SHIFT_GROUP, payload: shiftGroup });
export const updateShiftGroupSuccess = (shiftGroup) => ({ type: UPDATE_SHIFT_GROUP_SUCCESS, payload: shiftGroup });
export const updateShiftGroupFailure = (error) => ({ type: UPDATE_SHIFT_GROUP_FAILURE, payload: error });

// Delete Shift Group
export const deleteShiftGroup = (id) => ({ type: DELETE_SHIFT_GROUP, payload: id });
export const deleteShiftGroupSuccess = (id) => ({ type: DELETE_SHIFT_GROUP_SUCCESS, payload: id });
export const deleteShiftGroupFailure = (error) => ({ type: DELETE_SHIFT_GROUP_FAILURE, payload: error });
